import React, { useState } from "react";

const ReferenceDetails = (props) => {
  const [fields, setFields] = useState(props?.fields);

  return (
    <>
      <AppForm onSubmit={props.onReferenceDetailsSubmit}>
        {fields?.map((field, i) => {
          return (
            <div
              className={`col-12 col-md-${field?.customcolspan || 4} col-xl-3`}
              key={i}
            >
              <AppInput
                labelClass={"focus-label"}
                controlClass="floating"
                {...field}
                labelpos="top"
                className={"form-focus " + (field?.className || "")}
              ></AppInput>
            </div>
          );
        })}
        <div className="nav_container">
          <button
            className="formdata-cancel-btn btn"
            onClick={(...args) => props.onHandleStep(...args, 2)}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary ms-3">
            Continue & Preview
          </button>
        </div>
      </AppForm>
    </>
  );
};

export default constore(ReferenceDetails);
